import { AppType } from '@features/contexts/AppProvider';
import { CustomerRole, CustomerRoleT } from '@/api/apis/customer';
import { AssignedUsersByGroup, CaseUserGroup } from '@/api/apis/case';
import { UserRole } from '@/api/apis/user';
import { roleByCaseTxUserGroup, roleByCaseUserGroup } from '@/constants/case/case.constants';

export const showExtendedResourcesInfo = ({ appType }: { appType: AppType }) => appType === AppType.NopConnectPlatform;

export const mapEmployeeIdsByRole = (assignedEmployees: AssignedUsersByGroup) => {
  const result: Partial<Record<UserRole, string[]>> = {};
  Object.entries(assignedEmployees).forEach(([group, users]) => {
    const role = roleByCaseUserGroup[group as CaseUserGroup];
    if (role) {
      result[role] = users.map((u) => u.employeeId!);
    }
  });

  return result;
};

export const mapCustomersIdsByRole = (assignedCustomers: AssignedUsersByGroup) => {
  const result: Partial<Record<CustomerRoleT, string[]>> = {};
  Object.entries(assignedCustomers).forEach(([group, users]) => {
    const role = roleByCaseTxUserGroup[group as CaseUserGroup];
    if (role) {
      result[role] = users.map((u) => u.customerId!);
    }
  });

  return result;
};

export const mapUsersIdsByRoles = (
  assignedEmployees: AssignedUsersByGroup,
  assignedCustomers: AssignedUsersByGroup,
) => ({
  ...mapEmployeeIdsByRole(assignedEmployees),
  ...mapCustomersIdsByRole(assignedCustomers),
});

export const getLastAssignedTooltipMessage = (selectedRole: CustomerRoleT) => {
  switch (selectedRole) {
    case CustomerRole.TxCenterCoordinator:
      return 'At least one TX Center Coordinator should be assigned to case';
    case CustomerRole.ReceivingSurgeon:
      return 'At least one receiving TX Center Surgeon should be assigned to case';
    default:
      return '';
  }
};

export const getLastAssignedOPOContactTooltipMessage = () => {
  return 'At least one OPO Contact should be assigned to case';
};
